import React, {useEffect} from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import Error from '../../components/Error';
import {Controller, useForm} from 'react-hook-form';
import {isPositiveNumber, currencyFormat} from '../../utils';
import {depenses} from './data';

const FormAQSMI = ({setResultat, jumpTo}) => {
  const {register, handleSubmit, errors, watch, control} = useForm({
    mode: 'onChange',
    defaultValues: {
      montantImpot: 0,
    },
  });

  const onSubmit = (values) => {
    const results = depenses.map((depense) => {
      return {
        ...depense,
        value: Math.floor((values.montantImpot * depense.percent) / 100),
      };
    });

    setResultat(results);
  };

  useEffect(() => {
    register('montantImpot', {
      required: true,
      validate: (value) => isPositiveNumber(value),
    });
  }, [register]);

  const montantImpot = watch('montantImpot');

  return (
    <View>
      <View style={styles.container}>
        <View style={styles.text}>
          <View>
            Précisez le montant de votre impôt pour <br /> apprécier la
            répartition des dépenses publiques <br /> à laquelle il peut
            correspondre :
          </View>
        </View>
        <View style={styles.form}>
          <Controller
            control={control}
            name="montantImpot"
            render={(props) => (
              <TextInput
                value={props.value}
                onChangeText={props.onChange}
                placeholder="Entrez le montant de votre impôt"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
          />

          {errors.montantImpot?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}

          {errors.montantImpot?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </View>
      </View>
      <Button onPress={handleSubmit(onSubmit)} label="Lancer la simulation" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#10253F',
    marginBottom: 5,
    padding: 10,
  },
  text: {
    flex: 1,
    textAlign: 'center',
    color: '#FFF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    flex: 1,
  },
});

export default FormAQSMI;
